import useWidth from '@components/Hooks/useWidth';
import { useState } from 'react';
import {
  CatalogSidePanelContent,
  UseCatalogSidePanelParams,
  UseCatalogSidePanelResult,
} from './catalogSidePanel.types';

const CATALOG_DETAILS_CONTENT: CatalogSidePanelContent = 'details';

const useCatalogSidePanel = ({
  isDetailsAvailable,
}: UseCatalogSidePanelParams): UseCatalogSidePanelResult => {
  const { isCustomizedTabletDown } = useWidth();
  const [pickedContent, setPickedContent] = useState<CatalogSidePanelContent | null>();

  const defaultContent =
    isDetailsAvailable && !isCustomizedTabletDown ? CATALOG_DETAILS_CONTENT : null;
  const activeContent = pickedContent === undefined ? defaultContent : pickedContent;
  const isOpen = activeContent !== null;

  const toggle = (content: CatalogSidePanelContent) =>
    setPickedContent(activeContent === content ? null : content);

  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen) {
      setPickedContent(null);
    }
  };

  return { activeContent, isOpen, toggle, handleOpenChange };
};

export default useCatalogSidePanel;
